/**
 * Shared runtime constants.
 *
 * This module centralizes timing and tuning constants so UX adjustments do not
 * require hunting through individual components. If you need to tweak the boot
 * sequence speed or overlay fade timing, change it here — not in ten places.
 */

/** Initialization/boot-sequence tuning. */
export const INITIALIZATION = {
  /** Constant terminal typing speed (milliseconds per character). */
  TYPING_MS_PER_CHAR: 3.5,
  /** Minimum time the terminal stays visible before transitioning out. */
  MIN_TERMINAL_TIME_MS: 3000,
  /** Final pause after the last line has finished typing. */
  FINAL_PAUSE_MS: 500,
} as const;

/** End-of-run summary overlay transition tuning. */
export const SUMMARY_OVERLAY = {
  /**
   * How long to wait before setting `hidden` after starting fade-out.
   *
   * This should be at least the longest CSS transition used by `.overlay--summary`.
   */
  HIDE_AFTER_MS: 980,
} as const;

/** Bucket-hosted online manifest URL used by online mode. */
export const ONLINE_MANIFEST_URL =
  'https://media.universemakers.org/engine/run-manifest.json';

/** Backup manifest URL used when the primary media host is blocked. */
export const ONLINE_MANIFEST_BACKUP_URL =
  'https://pub-e00201311979473b8a30e279dcc56838.r2.dev/engine/run-manifest.json';

/**
 * API endpoint for run-selection tracking.
 *
 * In dev mode the Vite proxy forwards ``/api/track-run`` to the local tracking
 * server (``scripts/local_tracking_server.py``).  In production the absolute
 * Worker URL is used directly.
 */
export const TRACKING_API_URL = import.meta.env.DEV
  ? '/api/track-run'
  : 'https://api.universemakers.org/api/track-run';
